import React from "react";

// Global CRT scanlines, vignette, grain. Sits above content, below dialogs.
const CrtOverlay = () => {
  return (
    <>
      <div
        aria-hidden="true"
        className="crt-scanlines pointer-events-none fixed inset-0 z-[40] opacity-40"
        data-testid="crt-scanlines"
      />
      <div
        aria-hidden="true"
        className="crt-vignette pointer-events-none fixed inset-0 z-[39]"
      />
      <div
        aria-hidden="true"
        className="crt-grain pointer-events-none fixed inset-0 z-[38]"
      />
    </>
  );
};

export default CrtOverlay;
